import { FC } from "react";
import styled from "styled-components";
import { ContentfulTextPair } from "../lib/contentfulTypes";
import { button } from "../lib/sharedStyles";

export interface MultiTabProps extends ContentfulTextPair {
  id: string;
  brand: string;
  theme: string;
  isActive: boolean;
  onClick: () => void;
  tabStyle: string;
}

const Text = styled.div<{$isActive: boolean; $style: string; $brand: string; $theme: string;}>`
  position: relative;
  font-size: 16px;
  line-height: 29px;
  font-weight: 500;
  color: ${({ $isActive, $style, $brand }) => 
    $style == 'Button' && $brand == 'jackson' && $isActive ? '#FFF' : 
    $style == 'Button' && $brand == 'jackson' ? '#000' : 
    $isActive ? '#000' : '#666'};
  cursor: pointer;
  text-align: center;
  white-space: nowrap;

  ${({ $style }) => $style == 'Button' && `
    padding: 10px 24px;
  `}

  ${({ $style }) => $style == 'Underlined' && `
    margin: 0 12px;
    padding: 0 10px;
    line-height: 36px;

    @media (max-width: 768px) {
      height: 36px;
      white-space: nowrap;
    }
  `}

  ${({ $style, $brand }) => $style == 'Pill' && button('White Stroke Pill', $brand)};
  ${({ $style }) => $style == 'Pill' && `margin: 0 12px;`}

  &:hover {
    ${({ $style, $brand }) => $style == 'Pill' && button('Blue Pill', $brand)};
    border-color: #0083FF;
  }

  ${({ $style }) => $style == 'Black Stroke' && `
    &:hover {
      border: 1px solid #191A1F;
      border-radius: 100px;
      transition: none;
    }
  `}

  ${({ $style, $isActive }) => $style == 'Underlined' && $isActive && `
    &:after {
      content: "";
      display: block;
      width: 100%;
      position: absolute;
      height: 4px;
      top: 32px;
      bottom: 0;
      left: 0;
      border-radius: 2px;
      background: #0083FF;
    }
  `}

  ${({ $style, $isActive }) => $style == 'Button' && $isActive && `
    border-radius: 8px;
    background: #EAEAEA;
  `}

  ${({ $style, $isActive, $brand }) => $style == 'Pill' && $isActive && button('Blue Pill', $brand)};
  ${({ $style, $isActive }) => $style == 'Pill' && $isActive && `border-color: #0083FF;`}

  ${({ $style, $isActive }) => $style === 'Black Stroke' && `
    border: 1px solid ${$isActive ? '#191A1F' : 'transparent'};
    border-radius: 100px;
    padding: 10px 20px;
    margin: 0;
    transition: border-color 1.0s ease-in-out;
  `}

  ${({ $style, $brand, $isActive, $theme }) => $style == 'Button' && $brand == 'jackson' && `
    border-radius: 0;
    border: 1px solid ${$theme == 'dark' ? '#FFF' : '#000'};
    background: ${$isActive ? ($theme == 'dark' ? '#FFF' : '#000') : 'transparent'};
    color: ${$isActive ? ($theme == 'dark' ? '#000' : '#FFF') : ($theme == 'dark' ? '#FFF' : '#000')};
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background: ${$theme == 'dark' ? '#FFF' : '#000'};
      color: ${$theme == 'dark' ? '#000' : '#FFF'};
      border: 1px solid ${$theme == 'dark' ? '#FFF' : '#000'};
    }
  `}

  ${({ $brand }) => $brand == 'fender' && `
    font-weight: 600;
    letter-spacing: -0.02em;
  `}
`;

const MultiTab: FC<MultiTabProps> = ({ id, brand, theme, tabStyle, fields, isActive, onClick }) => (
  <Text 
    data-component-id={id}
    onClick={onClick} 
    $isActive={isActive} 
    $style={tabStyle} 
    $brand={brand}
    $theme={theme}
  >
    {fields.primaryText}
  </Text>
);

export default MultiTab;